export const px = (size: number): string => `${size}px`;
